var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLowPrice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 6,
    viewBox: "0 0 11 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.69654 2.50002C9.69654 2.2239 9.91384 1.99981 10.1816 1.99981C10.4494 1.99981 10.6667 2.2239 10.6667 2.50002V5.49979C10.6667 5.77592 10.4494 6 10.1816 6H7.27263C7.00487 6 6.78756 5.77592 6.78756 5.49979C6.78756 5.22367 7.00487 4.99959 7.27263 4.99959H9.69654V2.50002Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.142003 0.146436C0.33134 -0.0488119 0.638717 -0.0488119 0.828054 0.146436L3.63618 3.04295L5.71777 0.896379L5.79376 0.832663C5.98187 0.70453 6.23741 0.725736 6.40311 0.896379L10.5244 5.1463C10.7137 5.34151 10.7136 5.65778 10.5244 5.85304C10.3351 6.04829 10.0284 6.04829 9.83905 5.85304L6.06008 1.95685L3.9792 4.10341C3.78991 4.29862 3.48321 4.29854 3.29386 4.10341L0.142003 0.853902C-0.0473343 0.658655 -0.0473343 0.341683 0.142003 0.146436Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowPrice);
export default __webpack_public_path__ + "static/media/lowPrice.b617fdcbc017e6e5d3e73f05798228eb.svg";
export { ForwardRef as ReactComponent };